import { useRouter } from "@lib/i18n/navigation-pages-router";
import { useSearchParams } from "next/navigation";
import Cookies from "js-cookie";
import ahoy from "@lib/ahoy";
import { analytics } from "@lib/trackers/analytics";
import { useCheckAgainForCouponValidity } from "@hooks/use-tunnel-steps";
import { useEditProfile } from "@hooks/use-modify-user";
import TunnelStepsLayout from "@components/views/TunnelSteps/TunnelStepsLayout";
import CanonicalUrl from "@components/layout/CanonicalUrl";
import AuthComponent from "@components/views/Auth/Auth";

const Auth = () => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const editProfile = useEditProfile();
  const checkAgainForCouponValidity = useCheckAgainForCouponValidity();

  async function addFirstNameFromCookie(user) {
    const firstNameFromCookie = Cookies.get("first_name");

    if (!firstNameFromCookie || user?.first_name) return;

    await editProfile({ first_name: firstNameFromCookie });
  }

  async function goToNextTunnelStep(type, authBy, user) {
    await checkAgainForCouponValidity();

    if (type !== "signin") {
      ahoy("signupsuccess", { authBy });
      analytics.track("signupsuccess", { authBy });

      await addFirstNameFromCookie(user);
    }

    const queryStringified = searchParams.toString();
    const query = queryStringified ? `?${queryStringified}` : "";
    router.push(`/je-commence/ready-to-subscribe${query}`);
  }

  return (
    <TunnelStepsLayout
      currentSectionNumber={0}
      currentStepNumber={2}
    >
      <CanonicalUrl />

      <AuthComponent
        onAfterAuth={goToNextTunnelStep}
        initType="signup"
        withGoBackButton={true}
      />
    </TunnelStepsLayout>
  );
};

export default Auth;
